import PropTypes from 'prop-types'

import {
  Box,
  Button,
  Columns,
  Col,
  Dialog,
  Icon,
  Heading,
  Text,
} from '@redriverpress/system'

import ManageFlashcards from './ManageFlashcards'
import StyledDialogContent from '../StyledDialogContent'
import { flashcardsPropType } from '../propTypes'

export default function ManageFlashcardsDialog({
  deleteAllAction,
  flashcards,
  onRemove,
  onRename,
  onReorder,
  onClose,
  onOpenChange,
  onPrimaryAction,
  onPrint,
  open,
  primaryActionLabel,
  title,
  onCopy,
}) {
  const handlePrimaryAction = () => {
    onClose()
    onPrimaryAction()
  }

  const handlePrint = () => {
    onClose()
    onPrint()
  }

  return (
    <Dialog.Root open={open} onOpenChange={onOpenChange}>
      <Dialog.Portal>
        <Dialog.Overlay />
        <StyledDialogContent>
          <Box bg='white' p={3} pb={4}>
            <Dialog.Close
              position='absolute'
              top={[1, null, 2]}
              right={[1, null, 2]}
            />
            <Heading as='h3' mt={4} mb={2}>
              {title}
            </Heading>
            <Text color='gray700'>
              {flashcards.length} flashcard{flashcards.length !== 1 && 's'}
            </Text>
            <Columns pt={3}>
              <Col width={[1 / 2, null, 'auto']}>
                <Button
                  small
                  width={[1, null, 'auto']}
                  onClick={handlePrimaryAction}
                  disabled={flashcards.length === 0}
                >
                  {primaryActionLabel}
                </Button>
              </Col>
              <Col width={[1 / 2, null, 'auto']}>
                <Button
                  secondary
                  small
                  width={[1, null, 'auto']}
                  onClick={handlePrint}
                  disabled={flashcards.length === 0}
                >
                  <Icon icon='print' pr={2} />
                  Print
                </Button>
              </Col>
            </Columns>
          </Box>
          <ManageFlashcards
            deleteAllAction={deleteAllAction}
            flashcards={flashcards}
            onRemove={onRemove}
            onRename={onRename}
            onReorder={onReorder}
            onCopy={onCopy}
          />
        </StyledDialogContent>
      </Dialog.Portal>
    </Dialog.Root>
  )
}

ManageFlashcardsDialog.defaultProps = {
  deleteAllAction: null,
  onCopy: null,
}

ManageFlashcardsDialog.propTypes = {
  deleteAllAction: PropTypes.node,
  flashcards: flashcardsPropType.isRequired,
  onRemove: PropTypes.func.isRequired,
  onRename: PropTypes.func.isRequired,
  onReorder: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  onPrimaryAction: PropTypes.func.isRequired,
  onPrint: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  primaryActionLabel: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  onCopy: PropTypes.func,
}
